import { TileDeleteButton } from "@/components/ui-v2/Tiles/common/TileDeleteButton";
import {
  MeshPreviewTile,
  MeshPreviewTileProps,
} from "@/components/ui-v2/Tiles/MeshPreviewTile/MeshPreviewTile";

interface FileSelectPreviewListMeshTileProps extends MeshPreviewTileProps {
  onAction: (event: React.MouseEvent, action: string) => void;
}

export const FileSelectPreviewListMeshTile = (
  props: FileSelectPreviewListMeshTileProps,
) => {
  const { onAction, ...rest } = props;

  return (
    <MeshPreviewTile
      {...rest}
      onAction={onAction}
      slots={{
        bottomLeftEl: TileDeleteButton,
      }}
      slotProps={{
        bottomLeftEl: {
          onAction,
          sx: {
            m: 1,
          },
        },
      }}
    />
  );
};
